import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { useNavigate } from "react-router-dom";

import authService from "../../api-authorization/AuthorizeService";
import { AuthenticationResultStatus } from "../../api-authorization/AuthorizeService";
import { fetchWrapper } from "../../../helpers/fetchwrapper";

// Fluent UI Imports
import {
  MessageBar,
  Link,
  Image,
  Button,
  Input,
  Field,
  MessageBarActions,
  MessageBarBody,
  Tooltip,
  Spinner,
  Text,
  Checkbox,
} from "@fluentui/react-components";

import { baseUrl } from "../../../helpers/constants";
import { IAppUserDto } from "../../../Models/IAppUserDto";
import DataProtection from "../Manage/DataProtection";
import useWindowSize from "../../../helpers/useWindowSize";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import {
  ArrowLeftRegular,
  ArrowRightRegular,
  MailArrowClockwiseRegular,
  PersonKeyRegular,
} from "@fluentui/react-icons";

var emailRegEx = /\S+@\S+\.\S+/;

function Login(props: any) {
  const [capsLockOn, setCapsLockOn] = useState<boolean>(false);
  const navigate = useNavigate();
  const modul = window.location?.search?.substring(
    window.location?.search?.indexOf("&modul=") + 8,
  );

  const [logginIn, setLogginIn] = useState(false);
  const [loginValues, setLoginValues] = useState({
    loginState: 1,
    username: localStorage.getItem("signin_username") || "",
    password: "",
    isPersistent: false,
    loggedIn: false,
  });

  const [errorMessage, setErrorMessage] = useState("");

  const [emailValid, setEmailValid] = useState(
    emailRegEx.test(localStorage.getItem("signin_username") || ""),
  );
  const [eMailNotConfirmedError, setEmailNotConfirmedError] = useState(false);
  const [verificationSent, setVerificationSent] = useState(false);

  useEffect(() => {
    authService.getUser().then((user) => {
      if (user && loginValues.loginState != 3) {
        navigate("/");
      }
    });
  }, [loginValues.loginState]);

  const handleLoginValuesChange = (name: string, val: any) => {
    setEmailNotConfirmedError(false);
    setErrorMessage("");
    setVerificationSent(false);
    if (name === "username") localStorage.setItem("signin_username", val);
    setLoginValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
  };

  const CheckValidEMail = (value: string): string => {
    if (emailRegEx.test(value)) {
      setEmailValid(true);
      return "";
    } else {
      setEmailValid(false);
      return i18n.t<string>("enterValidEMail");
    }
  };

  const TryToAcceptEMail = (): void => {
    if (emailRegEx.test(loginValues.username)) {
      handleLoginValuesChange("loginState", 2);
    } else {
      ShowEmailMissingError();
    }
  };

  const ShowEmailMissingError = (): void => {};

  const resendVerificationEmail = () => {
    fetchWrapper
      .get(
        `${baseUrl}/api/account/ResendVerificationMail?email=${loginValues.username}`,
      )
      .then(() => {
        setVerificationSent(true);
        setEmailNotConfirmedError(false);
      });
  };

  const checkDataSecStatus = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/account/getcurrentuser`)
      .then((currentUser: IAppUserDto) => {
        if (currentUser.dataSecInitialSet) {
          navigate("/");
        } else {
          handleLoginValuesChange("loginState", 3);
        }
      })
      .catch((error) => {});
  };

  const LoginClicked = (): void => {
    setLogginIn(true);

    fetchWrapper
      .post(`${baseUrl}/api/account/login`, {
        UserId: loginValues.username,
        Password: loginValues.password,
        IsPersistent: loginValues.isPersistent,
        Platform: navigator?.platform ? navigator?.platform : "Unknown",
      })
      .then((result) => {
        if (result.message == "LOGIN_SUCCESS") {
          authService.signIn("/").then((result) => {
            switch (result.status) {
              case AuthenticationResultStatus.Redirect:
                break;
              case AuthenticationResultStatus.Success:
                fetchWrapper
                  .getWithAuth(
                    `${baseUrl}/api/account/setlanguage?language=${i18n.language}`,
                  )
                  .then((result) => {
                    checkDataSecStatus();
                  });
                break;
              case AuthenticationResultStatus.Fail:
                //TODO: Zu Fehlerseite navigieren
                break;
              default:
                throw new Error(`Invalid status result ${result.status}.`);
            }
          });
        } else if (result.message == "NOT_VERIFIED") {
          setEmailNotConfirmedError(true);
          setLogginIn(false);
        } else if (result.message == "USER_BLOCKED") {
          setErrorMessage(i18n.t<string>("userIsBlockedMsg"));
          setLogginIn(false);
        } else {
        }
      })
      .catch((error) => {
        if (error == "NOT_VERIFIED") {
          setEmailNotConfirmedError(true);
          setLogginIn(false);
        } else if (error == "USER_BLOCKED") {
          setErrorMessage(i18n.t<string>("userIsBlockedMsg"));
          setLogginIn(false);
        } else {
          setErrorMessage(i18n.t<string>(error));
          setLogginIn(false);
        }
      });
  };

  const windowSize = useWindowSize();

  return (
    <>
      <div
        className="blockContainerContentCentered"
        style={{ minHeight: "0px" }}
      >
        <div
          style={{
            borderRadius: "11px",
            backgroundColor: "white",
            boxShadow: "0 0 8px rgba(0,0,0,0.12), 0 32px 64px rgba(0,0,0,0.14)",
            minWidth: windowSize.width < 400 ? windowSize.width - 40 : 400,
            maxWidth: 500,
            marginRight: "auto",
            marginLeft: "auto",
            marginTop: 20,
            marginBottom: 20,
            animationDuration: "4s",
          }}
        >
          <div
            style={{
              padding: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Link onClick={() => navigate("/")}>
                <Image
                  style={{ marginBottom: "20px" }}
                  src={"/LUEBBERING_DIGITAL_512X512PX.PNG"}
                  height={50}
                />
              </Link>
            </div>
            <div className="lueb-padding5 lueb-MarginTopBottom10">
              {loginValues.loginState == 1 && (
                <>
                  <h3 style={{ marginBottom: "0px" }}>
                    {i18n.t<string>("signIn")}
                  </h3>
                  <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                    <Field>
                      <Input
                        name="username"
                        appearance="underline"
                        value={loginValues.username}
                        placeholder="E-Mail"
                        onChange={(ev, data) => {
                          CheckValidEMail(data ? data.value : "");
                          handleLoginValuesChange("username", data.value);
                        }}
                        /* onSubmit={() => {
                    TryToAcceptEMail();
                  }} */
                        onKeyDown={(data) => {
                          if (data.key == "Enter") {
                            TryToAcceptEMail();
                          }
                        }}
                      />
                    </Field>
                  </div>
                </>
              )}

              {!emailValid && (
                <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                  <MessageBar intent={"error"}>
                    {i18n.t<string>("enterValidEMail")}
                  </MessageBar>
                </div>
              )}

              {loginValues.loginState == 2 && (
                <>
                  <StackShim verticalAlign="stretch" horizontal>
                    <Button
                      style={{ marginBottom: "0px" }}
                      appearance="transparent"
                      disabled={logginIn}
                      icon={<ArrowLeftRegular />}
                      onClick={() => handleLoginValuesChange("loginState", 1)}
                    />
                    <h3 style={{ marginBottom: "0px" }}>
                      {i18n.t<string>("enterPassword")}
                    </h3>
                  </StackShim>
                  <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                    <div>
                      <Text style={{ marginBottom: "5px" }}>
                        {loginValues.username}
                      </Text>
                    </div>

                    <div style={{ marginBottom: 20, marginTop: 10 }}>
                      <Field
                        validationMessage={
                          capsLockOn ? i18n.t<string>("capsLockOn") : ""
                        }
                      >
                        <Input
                          appearance="underline"
                          name="current-password"
                          placeholder="Password"
                          type="password"
                          onChange={(ev, data) => {
                            handleLoginValuesChange("password", data.value);
                            setErrorMessage("");
                          }}
                          onKeyDown={(data) => {
                            if (data.key == "Enter") {
                              LoginClicked();
                            }
                            if (data.getModifierState("CapsLock")) {
                              setCapsLockOn(true);
                            } else {
                              setCapsLockOn(false);
                            }
                          }}
                        />
                      </Field>
                    </div>
                  </div>
                </>
              )}

              {loginValues.loginState == 3 && (
                <div>
                  <DataProtection />
                </div>
              )}

              {loginValues.loginState != 3 && (
                <div style={{ marginTop: "10px" }}>
                  <Checkbox
                    label={i18n.t<string>("rememberMe")}
                    checked={loginValues.isPersistent}
                    onChange={(ev, data) =>
                      handleLoginValuesChange("isPersistent", data.checked)
                    }
                  ></Checkbox>
                </div>
              )}

              <div style={{ marginTop: "10px" }}>
                {errorMessage != "" && (
                  <MessageBar intent={"error"}>{errorMessage}</MessageBar>
                )}

                {eMailNotConfirmedError == true && (
                  <MessageBar intent={"error"}>
                    <MessageBarBody>
                      {i18n.t<string>("eMailNotConfirmedError")}
                    </MessageBarBody>
                    <MessageBarActions
                      containerAction={
                        <Tooltip
                          content={i18n.t<string>("resendVerificationEmail")}
                          relationship={"label"}
                        >
                          <Button
                            appearance="transparent"
                            icon={<MailArrowClockwiseRegular />}
                            onClick={() => {
                              resendVerificationEmail();
                            }}
                          />
                        </Tooltip>
                      }
                    ></MessageBarActions>
                  </MessageBar>
                )}

                {verificationSent == true && (
                  <MessageBar intent={"success"}>
                    {i18n.t<string>("verificationWasSent")}
                  </MessageBar>
                )}
              </div>
            </div>
            {loginValues.loginState != 3 && (
              <div>
                <div className="lueb-padding5 lueb-MarginTopBottom10">
                  <span>
                    {i18n.t<string>("noAccount")}
                    <Link
                      onClick={() => {
                        if (modul) {
                          navigate("/account/register?modul=" + modul);
                        } else {
                          navigate("/account/register");
                        }
                      }}
                    >
                      {i18n.t<string>("createAccount")}
                    </Link>
                    !
                  </span>
                </div>
                <div className="lueb-padding5 lueb-MarginTopBottom10">
                  <Link
                    onClick={() => {
                      {
                        navigate("/account/forgotpassword");
                      }
                    }}
                  >
                    {i18n.t<string>("lostPassword")}
                  </Link>
                  ?
                </div>
              </div>
            )}
            <div className="lueb-padding5 lueb-MarginTopBottom10 lueb-floatRight">
              {loginValues.loginState == 1 && (
                <Button
                  appearance="primary"
                  icon={<ArrowRightRegular />}
                  iconPosition="after"
                  disabled={!emailValid}
                  onClick={() => {
                    TryToAcceptEMail();
                  }}
                >
                  {i18n.t<string>("next")}
                </Button>
              )}
              {loginValues.loginState == 2 && (
                <Button
                  appearance="primary"
                  icon={<PersonKeyRegular />}
                  disabled={logginIn}
                  onClick={() => LoginClicked()}
                >
                  {logginIn ? <Spinner></Spinner> : i18n.t<string>("signIn")}
                </Button>
              )}
              {loginValues.loginState == 3 && (
                <Button
                  appearance="primary"
                  iconPosition="after"
                  icon={<ArrowRightRegular />}
                  onClick={() => navigate("/")}
                >
                  {i18n.t<string>("next")}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
